/**
 * Created by Alican Köker on 2018-08-03.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {TimelineLite} from "gsap";
import {FruitsGameConfig} from "../../FruitsGameConfig";
import {FruitsGameModuleConfig} from "../../FruitsGameModuleConfig";
import {FruitsSoundConfig} from "../../FruitsSoundConfig";
import {FruitsGameMode} from "../../gamemode/FruitsGameMode";
import {FruitsReelController} from "../../reel/reel/FruitsReelController";
import {FruitsReelAreaView} from "../../reel/reelarea/FruitsReelAreaView";
import {FruitsReels} from "../../reel/reelarea/FruitsReels";
import {FruitsParsedGameData} from "../../server/data/FruitsParsedGameData";
import {FruitsHelper} from "../../utils/FruitsHelper";
import {FruitsBonusGameController} from "../FruitsBonusGameController";

export class BonusFeatureSymbolLandingController extends ReelStopPresentationController {

    private _roundData:FruitsParsedGameData;
    private _orientation:Orientation;
    private _bonusLeft:number;

    constructor(index:number) {
        super(index, "BonusScatterLanding");

        EventHandler.addEventListener(this, FruitsReelAreaView.GAME_MODE_SWITCHING_COMPLETED, (event:GameEvent) => this.onTransitionComplete(event.params[0]));
        EventHandler.addEventListener(this, FruitsReels.SET_ORIENTATION, (event:GameEvent) => this.onOrientationChange(event.params[0]));
    }

    protected parseFeatureGameData(data:FruitsParsedGameData):void {
        this._roundData = data;
        this._bonusLeft = data.bonusSpinsLeft;
    }

    public onReelBounce?(data:IReelStoppedData):void {
        if(data.reelId > 11 && this._gameData!.mode === FruitsGameMode.BONUS_GAME) {
            let sym:StateReelSymbol = Reels.getSymbol(data.reelId, 0)!;
            if(sym && sym!.symName.substr(0, 1) === "B")
                SlotGame.sound.playEffect(FruitsSoundConfig.B_LANDING);
        }
    }

    public onReelSpinStopped?(data:IReelStoppedData):void {
        let lastReel = this._orientation === Orientation.PORTRAIT ? 13 : 15;

        if(this._gameData!.mode === "BONUS_GAME") {

            let totalSpecialSymbolDelay:number = 0;
            let totalScatterDelay:number = 0;

            if(data.reelId === 11) {
                FruitsGameModuleConfig.bonusOverlayView.stopAttentions();
                SlotGame.sound.stopEffect("reelsSpin");
                SlotGame.sound.playEffect(FruitsSoundConfig.REELS_SPIN_BONUS);
                SlotGame.sound.playEffect(FruitsSoundConfig.BONUS_SWEEP_2);
                FruitsGameModuleConfig.bonusOverlayView.playReelGlossAnimaiton();
            }

            if(data.reelId === 15) {
                SlotGame.sound.stopEffect(FruitsSoundConfig.REELS_SPIN_BONUS);
                let delay:number = 1.4;
                let totalNumberOfScatters:number = 0;
                let scatterToPlay:boolean = false;

                let tl:TimelineLite = new TimelineLite();

                for(let i:number = 0; i < 4; i++) {
                    for(let j:number = 0; j < 4; j++) {
                        if(this._roundData.newBonusOverlayPositions[i][j]) {
                            scatterToPlay = true;
                            tl.add(() => {
                                FruitsGameModuleConfig.bonusOverlayView.stickScatter(i * 3 + j + 4);
                            }, .5);

                            tl.add(() => {
                                FruitsGameModuleConfig.bonusOverlayView.playBoltMotion(i * 3 + j + 4);
                            }, .5);

                            tl.add(() => {
                                FruitsGameModuleConfig.bonusOverlayView.updateMultiplier(undefined, true);
                            }, 1.5);
                            tl.add(() => {
                                FruitsGameModuleConfig.bonusGameController.updateScatterLevel(FruitsHelper.determineScatterLevel(this._roundData.collectedScatterAfter - 2));
                                FruitsGameModuleConfig.bonusOverlayView.updateScatterColor(this._roundData.collectedScatterBefore, this._roundData.collectedScatterAfter);
                            }, 2);
                            tl.add(() => {
                                EventHandler.dispatchEvent(new GameEvent(FruitsReelController.UPDATE_SCATTER_LEVEL, FruitsHelper.determineScatterLevel(this._roundData.collectedScatterAfter - 2)));
                                EventHandler.dispatchEvent(new GameEvent(FruitsBonusGameController.UPDATE_SCATTER_SYMBOLS));
                            }, 2.3);

                            totalNumberOfScatters++;
                        }
                    }
                }

                if(scatterToPlay)
                    tl.add(() => {
                        SlotGame.sound.playEffect(FruitsSoundConfig.LIGHTNING_SWEEP);
                    }, 1.1);

                totalScatterDelay = delay + .5;


                let b1Added:boolean = false;
                let b2Added:boolean = false;
                for(let i:number = 12; i < 16; i++) {
                    let sym:StateReelSymbol = Reels.getSymbol(i, 0)!;
                    if(sym) {
                        if(sym.symName === "B2") {
                            totalSpecialSymbolDelay += 1.1;
                            b2Added = true;
                        } else if(!b1Added && sym.symName === "B1") {
                            totalSpecialSymbolDelay += 1.8;
                            b1Added = true;
                        }
                    }
                }
                if(this._roundData.nextMode === FruitsGameMode.NORMAL && (b1Added || b2Added))
                    totalSpecialSymbolDelay += 2;

                let completeDispatchDelay:number =
                    b1Added || b2Added ? //any special symbol landed?                                           //1

                        //special symbol landed

                        //any scatter landed?
                        totalNumberOfScatters > 0 ?                                                             //2

                            //scatter landed
                            totalSpecialSymbolDelay + 4
                            :                                                                                   //2--

                            //no scatters landed

                            b2Added ? //b2 or b1?                                                               //3
                                //b2
                                totalSpecialSymbolDelay + 2.5 :                                                   //3---
                                //b1
                                totalSpecialSymbolDelay + 1
                        :                                                                                       //1----

                        //no special symbols landed

                        //any scatter landed?
                        totalNumberOfScatters > 0 ?                                                             //4
                            //scatter landed
                            3
                            :                                                                                   //4-
                            //no scatters landed
                            0
                ;

                if(((b1Added || b2Added) || totalNumberOfScatters > 0) && this._roundData!.nextMode === FruitsGameMode.NORMAL) {
                    completeDispatchDelay += .5;
                }

                tl.add(() => this.dispatchCompleteEvent(data.reelId), completeDispatchDelay);
                tl.play();

                this.playRightSideReels(totalNumberOfScatters > 0 ? 2 : 0);
            } else {
                this.dispatchCompleteEvent(data.reelId);
            }

        } else {
            this.dispatchCompleteEvent(data.reelId);
        }
    }

    private playRightSideReels(scatterDelay:number):void {
        let tl:TimelineLite = new TimelineLite();
        let extraSpinCount:boolean = false;
        let b1:boolean = false;

        for(let i:number = 0; i < 2; i++) {
            for(let j:number = 0; j < 2; j++) {
                if(this._roundData.bonusSpecialSymbolExtraSpin[i][j]) {
                    b1 = true;
                    let sym:StateReelSymbol = Reels.getSymbol(12 + i * 2 + j, 0)!;
                    tl.add(() => {
                        if(sym) {
                            sym.changeState({
                                state : FruitsGameConfig.instance.SYMBOL_STATES.win,
                                fadeInDuration : 0,
                                setStack : false
                            });
                            sym.currentStateAnimation!.playLoop();
                            FruitsGameModuleConfig.bonusOverlayView.playBonusAnim(12 + i * 2 + j, "B1");
                        }
                    }, scatterDelay);
                    tl.add(() => {
                        SlotGame.keypad.setZeroBetSpinCounter(this._bonusLeft);
                        SlotGame.sound.playEffect(FruitsSoundConfig.LIGHTNING_PLUS_ONE_KEYPAD);
                    }, scatterDelay + 1
                    );
                    extraSpinCount = true;
                }
            }
        }
        if(b1)
            tl.add(() => {SlotGame.sound.playEffect(FruitsSoundConfig.LIGHTNING_PLUS_ONE)}, scatterDelay);
        let multiplierSymbolCount:number = 0;

        for(let i:number = 0; i < 2; i++) {
            for(let j:number = 0; j < 2; j++) {
                if(this._roundData.bonusSpecialSymbolMultiplier[i][j]) {
                    multiplierSymbolCount++;
                    let sym:StateReelSymbol = Reels.getSymbol(12 + i * 2 + j, 0)!;
                    if(sym) {
                        tl.add(() => {
                            sym.changeState({
                                state : FruitsGameConfig.instance.SYMBOL_STATES.win,
                                fadeInDuration : 0,
                                setStack : false
                            });
                            sym.currentStateAnimation!.playLoop();
                            FruitsGameModuleConfig.bonusOverlayView.playBonusAnim(12 + i * 2 + j, "B2");
                            SlotGame.sound.playEffect(FruitsSoundConfig.LIGHTNING_LEVEL_UP);
                        }, scatterDelay + multiplierSymbolCount * 1.2 + (extraSpinCount ? 1 : 0));
                    }
                    tl.add(() => {
                        FruitsGameModuleConfig.bonusOverlayView.updateMultiplier(true, false);
                    }, scatterDelay + multiplierSymbolCount * 1.2 + (extraSpinCount ? 2 : 1));
                }
            }
        }

        tl.add(() => {})

        tl.play();
    }

    private onTransitionComplete(nextMode:FruitsGameMode):void {
        if(this._roundData && nextMode === FruitsGameMode.BONUS_GAME) {
            let rInd:number = 0, sInd:number = 0;
            this._roundData.bonusOverlayPositionsAfter.forEach((reel) => {
                sInd = 0;
                reel.forEach((sym) => {
                    if(sym) {
                        //FruitsGameModuleConfig.bonusOverlayView.stickScatter(rInd * 3 + sInd + 4, true);
                    }
                    sInd++;
                });
                rInd++;
            });
        }
    }

    private onOrientationChange(orientation:Orientation) {
        this._orientation = orientation;
    }
}